import Vuex from 'vuex'
import Vue from 'vue'
import ingredients from './modules/ingredients'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    ingredients
  },
  strict: process.env.NODE_ENV !== 'production'
})
